export class CleoConversationMessageTool {
    public id: number | null;
    public cleo_conversation_message_id: number | null;
    public event: string;
    public plugin: string;
    public function_name: string;
    public args: Record<string, string> | null;
    public result: string | null;
    public error: string | null;
    public sort_order: number | null;

    constructor(data?: CleoConversationMessageToolData) {
        if (data === undefined) {
            this.id = null;
            this.cleo_conversation_message_id = null;
            this.event = '';
            this.plugin = '';
            this.function_name = '';
            this.args = null;
            this.result = null;
            this.error = null;
            this.sort_order = null;
        } else {
            this.id = data.id;
            this.cleo_conversation_message_id = data.cleo_conversation_message_id;
            this.event = data.event;
            this.plugin = data.plugin;
            this.function_name = data.function_name;
            this.args = data.args;
            this.result = data.result;
            this.error = data.error;
            this.sort_order = data.sort_order ?? null;
        }
    }
}

export type CleoConversationMessageToolData = {
    id: number | null;
    cleo_conversation_message_id: number | null;
    event: string;
    plugin: string;
    function_name: string;
    args: Record<string, string> | null;
    result: string | null;
    error: string | null;
    sort_order: number | null;
}
